import React from 'react'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'
import { Container, Header, Label, Divider, Segment } from 'semantic-ui-react'
import { CommentCount } from 'disqus-react'

const BlogPage = ({
  data: {
    allMarkdownRemark: { edges },
  },
}) => {
  const Posts = edges
    .filter(edge => !!edge.node.frontmatter.date)
    .map(({ node: { frontmatter: post } }) => {
      return (
        <Segment key={post.id} stacked textAlign='center' padded='very'>
          <Header as='h2' content={<Link to={post.path}>{post.title}</Link>} />
          <Label icon='time' size='tiny' basic content={post.date} />
          <Label
            icon='comment'
            size='tiny'
            basic
            content={
              <CommentCount
                shortname='fake-flight-tickets'
                config={{
                  url: `https://www.fakeflighttickets.com${post.path}`,
                  identifier: post.id,
                  title: post.title,
                }}
              />
            }
          />
        </Segment>
      )
    })

  return (
    <Container text>
      <Helmet>
        <title>Блог - Фэйковые Авиабилеты</title>
        <meta name='twitter:title' content='Блог - Фэйковые Авиабилеты' />
        <meta name='twitter:image' content='/opengraph-image.ru.jpg' />
        <meta property='og:image' content='/opengraph-image.ru.jpg' />
      </Helmet>
      <Header as='h1'>Наш Блог</Header>
      {Posts}
      <center style={{ marginTop: '10vh' }}>
        Хотите разместить свою статью в нашем блоге?
        <br />
        Тогда шлите <i>полный текст статьи</i> на наш{' '}
        <a
          onClick={() => {
            window.open('mailto:hello' + '@' + 'fakeflighttickets.com', '_blank')
          }}
          className='item'
          target='_blank'>
          имэйл
        </a>
        .<br />
        Если Ваша статья нам понравиться, то мы её разместим и даже дадим бесплатные
        билетики ;)
      </center>
    </Container>
  )
}

export default BlogPage

export const pageQuery = graphql`
  query IndexQueryRu {
    allMarkdownRemark(sort: { order: DESC, fields: [frontmatter___date] }) {
      edges {
        node {
          id
          excerpt(pruneLength: 250)
          frontmatter {
            date(formatString: "MMMM DD, YYYY")
            path
            title
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/blog.ru.js